export const ru = {
    isNotSet: 'не задан',
    perDay: 'в день'
};
